module.exports = __webpack_public_path__ + "img/10-7.26ed0d0c.jpg";